/**
 * BS PDP Interactions — wspolny, idempotentny handler dla sekcji PDP.
 * Obsluguje: reveal on-scroll, akordeony (FAQ), hotspoty przekroju <-> warstwy.
 * Wzorzec: delegacja zdarzen na document (odporna na shopify:section:load,
 * nie wymaga re-bindu) + re-skan reveal po przeladowaniu sekcji w edytorze.
 */
(function () {
  'use strict';

  /* ---------- reveal on-scroll ---------- */
  var revealIO = null;
  function getRevealIO() {
    if (revealIO) return revealIO;
    if (!('IntersectionObserver' in window)) return null;
    revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          revealIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    return revealIO;
  }
  function scanReveal(root) {
    var io = getRevealIO();
    var els = (root || document).querySelectorAll('.bs-reveal:not([data-bs-rev])');
    els.forEach(function (el) {
      el.setAttribute('data-bs-rev', '1');
      if (io) { io.observe(el); } else { el.classList.add('is-in'); }
    });
  }

  /* ---------- akordeony (FAQ) ---------- */
  document.addEventListener('click', function (ev) {
    var q = ev.target.closest('[data-bs-acc-q]');
    if (!q) return;
    var item = q.closest('[data-bs-acc-item]');
    if (!item) return;
    item.classList.toggle('is-open');
    var expanded = item.classList.contains('is-open');
    q.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  });

  /* ---------- hotspoty przekroju <-> warstwy ---------- */
  function activateLayer(container, index) {
    container.querySelectorAll('[data-bs-layer]').forEach(function (el) {
      el.classList.toggle('is-on', el.getAttribute('data-bs-layer') === String(index));
    });
  }
  document.addEventListener('click', function (ev) {
    var node = ev.target.closest('[data-bs-layer]');
    if (!node) return;
    var container = node.closest('[data-bs-hotspots]');
    if (!container) return;
    var index = node.getAttribute('data-bs-layer');
    activateLayer(container, index);

    // Klik hotspota na grafice -> przewin do przypisanej warstwy (glownie mobile,
    // gdzie warstwy sa pod przekrojem). Na desktopie warstwa jest obok grafiki i
    // zwykle juz widoczna -> nie scrollujemy, zeby nie robic brzydkiego skoku.
    if (node.classList.contains('bs-hot')) {
      var target = container.querySelector('.bs-layer[data-bs-layer="' + index + '"]');
      if (target) {
        var rect = target.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var fullyVisible = rect.top >= 0 && rect.bottom <= vh;
        if (!fullyVisible) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }
  });

  /* ---------- stepper ilosci (buy-box) ---------- */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-bs-qty-step]');
    if (!btn) return;
    var wrap = btn.closest('[data-bs-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('.bs-qty__input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-bs-qty-step'), 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var val = parseInt(input.value, 10) || min;
    val = val + step;
    if (val < min) val = min;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- selektor rozmiaru (warianty Shopify) -> jedno zrodlo prawdy ---------- */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-bs-size]');
    if (!btn) return;
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var wrap = btn.closest('[data-bs-variants]');
    var box = btn.closest('.bs-buy') || document;
    var id = btn.getAttribute('data-variant-id');
    var price = btn.getAttribute('data-price');
    var wymiary = btn.getAttribute('data-wymiary');
    var url = btn.getAttribute('data-url');

    // stan aktywnego przycisku
    if (wrap) {
      wrap.querySelectorAll('[data-bs-size]').forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    // ukryty input wariantu dla add-to-cart
    var hidden = box.querySelector('.product-variant-id');
    if (hidden && id) { hidden.value = id; hidden.removeAttribute('disabled'); }
    // cena w buy-boxie
    var priceEl = box.querySelector('.bs-buy__price .price-item--regular');
    if (priceEl && price) { priceEl.textContent = price; }
    // ?variant= w URL (bez przeladowania)
    if (url && window.history && history.replaceState) {
      try { history.replaceState({}, '', url); } catch (e) {}
    }
    // jedno zrodlo prawdy: emituj event dla innych sekcji (paszport: wymiary)
    document.dispatchEvent(new CustomEvent('bs:variant-change', {
      detail: { variantId: id, price: price, wymiary: wymiary }
    }));
  });

  /* ---------- paszport: pole "wymiary" variant-aware (sluchacz, raz) ---------- */
  document.addEventListener('bs:variant-change', function (e) {
    var w = e.detail && e.detail.wymiary;
    if (!w) return;
    document.querySelectorAll('[data-bs-wymiary-dd]').forEach(function (el) {
      el.textContent = w;
    });
  });

  /* ---------- init ---------- */
  function init(root) { scanReveal(root); }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', function () { init(); }); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
